import { atom, selector, selectorFamily } from "recoil";
import ServiceAuth from "src/services/auth/authToken";
import ServicePatient from "src/services/patient/patient";

export const activeStepDeleteUserState = atom({
    key: "activeStepDeleteUser",
    default: 0,
  });

export const completedStepDeleteUserState = atom({
  key: "completedStepDeleteUser",
  default: {},
});